import React from 'react';
import block from 'bem-cn-lite';
import {Text} from '@gravity-ui/uikit';

import './Quantity.scss';

const b = block('quantity');

export interface QuantityProps {
    value: number;
    className?: string;
}

export const Quantity: React.FC<QuantityProps> = (props) => {
    return (
        <div className={`${b(null, props.className)}`}>
            <Text variant={'body-1'}>
                {props.value}
            </Text>
        </div>
    );
};